export default __webpack_public_path__ + "static/media/banner-image-4.361afc5b.JPG";